import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cb32e3c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-10"
}
const _hoisted_2 = {
  key: 1,
  class: "p-2"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-bold block" }, "Job templates", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-base pt-3 block" }, " Use these templates to speed up the filling of information about your job vacancies. It will be filled as editable text so you can use them as a base or as is. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center pt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-200" })
], -1))
const _hoisted_6 = { class: "w-full flex flex-row" }
const _hoisted_7 = { class: "space-y-3 w-1/3 border-r-2 border-gray-200 p-5" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "block pt-2 font-bold" }, "Job", -1))
const _hoisted_9 = {
  key: 0,
  class: "h-52 space-y-3 overflow-y-auto p-2"
}
const _hoisted_10 = {
  key: 1,
  class: "text-primary"
}
const _hoisted_11 = { class: "w-2/3 p-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold block" }, "Description", -1))
const _hoisted_13 = {
  key: 0,
  class: "text-xs"
}
const _hoisted_14 = {
  key: 1,
  class: "text-primary"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-200" })
], -1))
const _hoisted_16 = { class: "flex flex-row justify-between pt-3" }
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_RadioButton = _resolveComponent("RadioButton")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Loading, {
          active: _ctx.isLoading,
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
          "can-cancel": false,
          loader: "spinner",
          color: "#8908F9",
          width: 100,
          height: 100,
          "is-full-page": false
        }, null, 8, ["active"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            (_ctx.templeteOptions && _ctx.templeteOptions.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templeteOptions, (item, index) => {
                    return (_openBlock(), _createBlock(_component_RadioButton, {
                      key: `radio-${item.value}-${index}`,
                      label: item.title,
                      fontSize: "text-xs",
                      value: item.id,
                      modelValue: _ctx.radioOption,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.radioOption) = $event))
                    }, null, 8, ["label", "value", "modelValue"]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_10, "No options"))
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            (_ctx.radioOption !== '')
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.templateDescription && JSON.parse(_ctx.templateDescription.content)[0]), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.templeteOptions && _ctx.templeteOptions.length > 0
              ? "Select any option."
              : ""), 1))
          ])
        ]),
        _hoisted_15,
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
            class: "px-4 py-2 border-2 border-primary text-primary rounded-full"
          }, " Cancel "),
          _createElementVNode("button", {
            disabled: _ctx.radioOption === '',
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveTemplate && _ctx.saveTemplate(...args))),
            class: "px-4 py-2 bg-primary text-white rounded-full disabled:opacity-50"
          }, " Add selection ", 8, _hoisted_17)
        ])
      ]))
}